import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendToyotaPremiumHotaiGo } from 'pages/lexusOfficialAccount/utils/LinePostbackActions';

import useLineLiff from 'hooks/LineLiff';

const ToyotaPremiumHotaiGo = () => {
  const { liff, userInfo } = useLineLiff(process.env.REACT_APP_LIFF_HOTAI_GO);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo) {
      return;
    }
    const processValidation = async () => {
      try {
        const idToken = liff.getIDToken();
        const accessToken = liff.getAccessToken();

        if (!liff.isLoggedIn()) {
          setTimeout(processValidation, 500);
          return;
        }

        // 如果沒有 idToken，先用 accessToken 作為 fallback（需後端配合）
        const tokenToSend = idToken || accessToken;
        if (!tokenToSend) {
          alert(
            '無法取得 idToken 或 accessToken，請確認 LIFF 已登入與權限設定'
          );
          return;
        }

        const response = await sendToyotaPremiumHotaiGo(tokenToSend);

        if (!response.success) {
          navigate('/hotai/login', { replace: true });
          return;
        }

        if (response?.data?.redirect_url) {
          window.location.href = response.data.redirect_url;
        }

        if (response?.data?.message) {
          alert(response.data.message);
        }
      } catch (error) {
        console.error('Error sending reurl tag:', error);
      }
    };

    processValidation();
  }, [liff, userInfo]);

  return <div></div>;
};

export default ToyotaPremiumHotaiGo;
